import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

const API = "https://admin.bridge365.in/wp-json/wc/v3";
const CK = "ck_1d0bfb52b9046a39fb2d906f89f691968931bce6";
const CS = "cs_956c51f2c9249f343bec7f0ecbfd7738654ba424";

function decodeHTML(html) {
  const txt = document.createElement("textarea");
  txt.innerHTML = html || "";
  return txt.value;
}

function buildCategoryTrail(categories, categoryId) {
  const trail = [];
  const seen = new Set();
  let current = categories.find((cat) => cat.id === Number(categoryId));

  while (current && !seen.has(current.id)) {
    seen.add(current.id);
    trail.unshift(current);
    if (!current.parent) break;
    current = categories.find((cat) => cat.id === current.parent);
  }

  return trail;
}

function pickDeepestTrail(categories, categoryIds) {
  let deepest = [];

  categoryIds.forEach((categoryId) => {
    const trail = buildCategoryTrail(categories, categoryId);
    if (trail.length > deepest.length) {
      deepest = trail;
    }
  });

  return deepest;
}

function Breadcrumb({
  items,
  categoryId,
  categoryIds,
  categories: categoriesProp,
  currentLabel,
  className = "",
}) {
  const [fetchedCategories, setFetchedCategories] = useState([]);
  const resolvedCategoryIds = (categoryIds || (categoryId ? [categoryId] : []))
    .filter(Boolean)
    .map(Number);

  useEffect(() => {
    if (items || categoriesProp || resolvedCategoryIds.length === 0) return;

    fetch(`${API}/products/categories?per_page=100&consumer_key=${CK}&consumer_secret=${CS}`)
      .then((res) => res.json())
      .then((data) => setFetchedCategories(Array.isArray(data) ? data : []))
      .catch(() => setFetchedCategories([]));
  }, [items, categoriesProp, resolvedCategoryIds.join(",")]);

  const categories = categoriesProp || fetchedCategories;

  const crumbs = useMemo(() => {
    if (Array.isArray(items) && items.length > 0) {
      return items;
    }

    const nextCrumbs = [{ label: "Home", to: "/" }];
    const trail = pickDeepestTrail(categories, resolvedCategoryIds);

    trail.forEach((cat, index) => {
      const isLastCategory = index === trail.length - 1 && !currentLabel;
      nextCrumbs.push({
        label: decodeHTML(cat.name),
        to: isLastCategory ? undefined : `/category/${cat.id}`,
      });
    });

    if (trail.length === 0 && !currentLabel && resolvedCategoryIds.length === 0) {
      nextCrumbs.push({ label: "All Products" });
    }

    if (currentLabel) {
      nextCrumbs.push({ label: decodeHTML(currentLabel) });
    }

    return nextCrumbs;
  }, [items, categories, resolvedCategoryIds.join(","), currentLabel]);

  return (
    <nav className={`site-breadcrumb ${className}`.trim()} aria-label="Breadcrumb">
      {crumbs.map((item, index) => {
        const isLast = index === crumbs.length - 1;

        return (
          <React.Fragment key={`${item.label}-${index}`}>
            {index > 0 ? <span className="site-breadcrumb-sep">&gt;</span> : null}
            {isLast || !item.to ? (
              <span className="site-breadcrumb-current">{item.label}</span>
            ) : (
              <Link to={item.to}>{item.label}</Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

export default Breadcrumb;
